module.exports = __webpack_public_path__ + "assets/img/close.58c5896f.png";